import mainMenu from '../frctl/components/02-molecules/main-menu/main-menu';
import loadMorePosts from './modules/loadMorePosts';
import heroVideo from './modules/heroVideo';
import expandingCards from './modules/expandingCards';

window.addEventListener('load', mainMenu);
window.addEventListener('load', loadMorePosts);
window.addEventListener('load', heroVideo);
window.addEventListener('load', expandingCards);
